import { Gender, Honorific } from "./types";

export const HONORIFIC_GENDER_MAP: Record<Honorific, Gender> = {
  MR: "M",
  MRS: "F",
  MISS: "F",
};
